import { apiSlice } from '@redux/apiSlice'
import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import { siteSlice } from './site/siteSlice'

export const store = configureStore({
  reducer: persistReducer(
    {
      key: 'root',
      storage,
      whitelist: [],
      blacklist: [apiSlice.reducerPath],
    },
    combineReducers({
      [apiSlice.reducerPath]: apiSlice.reducer,
      site: siteSlice.reducer,
    }),
  ),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      apiSlice.middleware,
    ),
  devTools: !import.meta.env.PROD,
})

export const persistor = persistStore(store)

setupListeners(store.dispatch)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _window: any = window

if (_window.Cypress) {
  _window.store = store
}

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
